import { render, staticRenderFns } from "./App.vue?vue&type=template&id=16cce571"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=16cce571&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9f5380727b4593b5be9ce18f0d050674/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports